import { render, staticRenderFns } from "./PicturePreviewModal.vue?vue&type=template&id=28c78796&scoped=true"
import script from "./PicturePreviewModal.vue?vue&type=script&lang=js"
export * from "./PicturePreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PicturePreviewModal.vue?vue&type=style&index=0&id=28c78796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c78796",
  null
  
)

export default component.exports